import endpoints from './endpoints';

const host = 'https://stg.posillicocms.com';
const api = 'https://posillico-cms-stg-b75cfbee0a17.herokuapp.com';

export default {
	host,
	api,

	bucket: 'https://posillicocmsstorage.blob.core.windows.net/production',

	// TODO :: add GET so we don't have to do "setFeatureFlags" etc...
	endpoints: endpoints(api),
};
